import { render, staticRenderFns } from "./PrequalifiedTable.vue?vue&type=template&id=2b2a50d8&"
import script from "./PrequalifiedTable.vue?vue&type=script&lang=js&"
export * from "./PrequalifiedTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports